import { colors, fonts } from "../Styles"

export enum FieldStyles {
    greyTertiary = "greyTertiary",
    greyDarkSecondary = "greyDarkSecondary",
    greyDarkPrimary = "greyDarkPrimary",
    greySecondary = "greySecondary",
    popoverDropdown = "popoverDropdown",
    blueDarkSecondary = "blueDarkSecondary"
  }
  
export const CreateFieldStyle = (fieldStyle?: FieldStyles|string) => {
  let fontStyle
  let backgroundColor
  let hoverColor
  let borderColor
  let dropdownColor
  let scrollbarColor

  switch (fieldStyle) {
    case 'greyTertiary':
      fontStyle = {...fonts.paragraph, ...fonts.fontSize4, color: colors.greyDarkPrimary}
      backgroundColor = {backgroundColor: colors.greyTertiary}
      hoverColor = {backgroundColor: colors.greySecondary}
      borderColor = {borderColor: colors.greySecondary}
      dropdownColor = {backgroundColor: colors.greyTertiary}
      scrollbarColor = {scrollbarColor: colors.greySecondary+colors.transparent}
    break
    case 'greyDarkSecondary':
      fontStyle = {...fonts.paragraph, ...fonts.fontSize3, color: colors.greyLightTertiary}
      backgroundColor = {backgroundColor: colors.greyDarkSecondary}
      hoverColor = {backgroundColor: colors.greyDarkPrimary}
      borderColor = {borderColor: colors.greyDarkPrimary}
      dropdownColor = {backgroundColor: colors.greyDarkSecondary}
      scrollbarColor = {scrollbarColor: colors.greyDarkPrimary+colors.transparent}
    break
    case 'greyDarkPrimary':
      fontStyle = {...fonts.paragraph, ...fonts.fontSize3, color: colors.greyLightTertiary}
      backgroundColor = {backgroundColor: colors.greyDarkPrimary}
      hoverColor = {backgroundColor: colors.greyDarkSecondary}
      borderColor = {borderColor: colors.greyDarkSecondary}
      dropdownColor = {backgroundColor: colors.greyDarkPrimary}
      scrollbarColor = {scrollbarColor: colors.greyDarkSecondary+colors.transparent}
    break
    case 'greySecondary':
      fontStyle = {...fonts.paragraph, ...fonts.fontSize3, color: colors.greyLightTertiary}
      backgroundColor = {backgroundColor: colors.greySecondary}
      hoverColor = {backgroundColor: colors.greyPrimary}
      borderColor = {borderColor: colors.greyPrimary}
      dropdownColor = {backgroundColor: colors.greySecondary}
      scrollbarColor = {scrollbarColor: colors.greyPrimary+colors.transparent}
    break
    case 'popoverDropdown':
      fontStyle = {...fonts.paragraph, ...fonts.fontSize3, color: colors.greyLightTertiary}
      backgroundColor = {backgroundColor: colors.blueDarkSecondary}
      hoverColor = {backgroundColor: colors.greyDarkSecondary}
      borderColor = {borderColor: colors.greyDarkSecondary}
      dropdownColor = {borderColor: colors.greyDarkPrimary}
      scrollbarColor = {scrollbarColor: colors.greyDarkSecondary+colors.transparent}
    break
    case 'blueDarkSecondary':
    default:
      fontStyle = {...fonts.paragraph, ...fonts.fontSize3, color: colors.greyLightTertiary}
      backgroundColor = {backgroundColor: colors.blueDarkSecondary}
      hoverColor = {backgroundColor: colors.blueDarkPrimary}
      borderColor = {borderColor: colors.blueDarkPrimary}
      dropdownColor = {backgroundColor: colors.blueDarkSecondary}
      scrollbarColor = {scrollbarColor: colors.blueDarkPrimary+colors.transparent}
    break
  }

  return { fontStyle, backgroundColor, hoverColor, borderColor, dropdownColor, scrollbarColor }
}